import React, { Component, lazy, Suspense } from "react";
import { Button, Container, Header, Icon, Image } from "semantic-ui-react";
import { Link } from "react-router-dom";
import Sidebar from "../../components/shared/sidebar";
import Footer from "../../components/shared/footer";
import HeaderInfo from "../../components/shared/header";
import "./home.css";

const ProjectCards = lazy(() => import("../../components/project-cards"));
const ArticleCards = lazy(() => import("../../components/article-cards"));
const ContactCards = lazy(() => import("../../components/contact-cards"));

const Loading = () => (
  <div>
    <Image src="/static/images/loading-d.gif" className="loading" />
  </div>
);

class Home extends Component {
  state = { menuOpen: false };

  handleStateChange = (state) => this.setState({ menuOpen: state.isOpen });

  toggleMenu = () =>
    this.setState((prevState) => ({ menuOpen: !prevState.menuOpen }));

  renderSection = (title, subtitle, component, link = null) => (
    <>
      <Header as="h3">
        <Header.Content>
          {title}
          {subtitle && (
            <Header.Subheader>
              {subtitle} {link && <Link to={link}> (View all)</Link>}
            </Header.Subheader>
          )}
        </Header.Content>
      </Header>
      <Suspense fallback={<Loading />}>{component}</Suspense>
    </>
  );

  render() {
    return (
      <div id="App">
        <Sidebar
          pageWrapId="main-content"
          outerContainerId="App"
          isOpen={this.state.menuOpen}
          onStateChange={this.handleStateChange}
          active={"home"}
        />
        <main id="main-content">
          <Container>
            <div className="header-content">
              <HeaderInfo />
              <Button basic icon size="big" onClick={this.toggleMenu}>
                <Icon name="bars" />
              </Button>
            </div>

            {this.renderSection(
              "Things I've made",
              "I've made many projects",
              <ProjectCards />
            )}
            {this.renderSection(
              "Articles",
              "I like to write in my free time",
              <ArticleCards />,
              "/articles"
            )}
            {this.renderSection(
              "Contact",
              "If you require any further information, feel free to contact me!",
              <ContactCards />
            )}

            <Footer />
          </Container>
        </main>
      </div>
    );
  }
}

export default Home;
